import { useMutation, useQueryClient } from 'react-query';
import api from 'src/services/api';
import { COMPANY_MEMBERS_QUERY_KEY, CUSTOMER_QUERY_KEY, USER_QUERY_KEY } from 'src/constants/query';
import { customerIdSelector } from 'src/selectors/customer';
import useQueryData from '../useQueryData';

const disableMfa = userId => api.post(`/user/${userId}/mfa/disable`);

export default function useDisableMfa() {
  const queryClient = useQueryClient();
  const customerId = useQueryData(CUSTOMER_QUERY_KEY, customerIdSelector);

  return useMutation(userId => disableMfa(userId), {
    onSuccess: (_, userId) => {
      queryClient.setQueryData([COMPANY_MEMBERS_QUERY_KEY, customerId], oldData => {
        if (!oldData) return oldData;
        return {
          ...oldData,
          pages: oldData.pages.map(page => ({
            ...page,
            companyMembers: page.companyMembers.map(user =>
              user.userId === userId ? { ...user, twoFactorEnabled: false } : user,
            ),
          })),
        };
      });
      queryClient.invalidateQueries(USER_QUERY_KEY);
    },
  });
}
